import location from "../assets/icons/location.svg";
import locationAct from "../assets/icons/locationAct.svg";
import trend from "../assets/icons/trend.svg";
import trendAct from "../assets/icons/trendAct.svg";
import cate from "../assets/icons/cate.svg";
import cateAct from "../assets/icons/cateAct.svg";
import calendar from "../assets/icons/calendar.svg";
import calendarAct from "../assets/icons/calendarAct.svg";
import user from "../assets/icons/user.svg";
import userAct from "../assets/icons/userAct.svg";
import home from "../assets/icons/home.svg";
import homeAct from "../assets/icons/homePurple.svg";
import commentPurpleAct from "../assets/icon/commentPurpleAct.svg";
import comments from "../assets/icon/comments.svg";
import photoLibraryWhite from "../assets/icon/photo_library_white.png";
import orgPurple from 'assets/icons/orgPurple.svg';
import orgWhite from 'assets/icons/orgWhite.svg';
import servicePurple from 'assets/icons/servicePurple.svg';
import serviceWhite from 'assets/icons/serviceWhite.svg';
import barberPurple from 'assets/icons/barberPurple.svg';
import barberWhite from 'assets/icons/barberWhite.svg';


export const ICON = {
    photoLibraryWhite,
    location,
    locationAct,
    trend,
    trendAct,
    cate,
    cateAct,
    calendar,
    calendarAct,
    user,
    userAct,
    home,
    homeAct,
    comments,
    commentPurpleAct,
    orgPurple, orgWhite,
    servicePurple, serviceWhite,
    barberPurple, barberWhite
};
